import React from 'react';
import { Container } from 'flux/utils';

import settingsStore from '../stores/settings';

import Settings from './settings';

class SettingsContainer extends React.Component {
  static getStores() {
    return [settingsStore];
  }

  static calculateState() {
    return {
      settings: settingsStore.getState(),
    };
  }

  render() {
    return <Settings {...this.state} />;
  }
}

export default Container.create(SettingsContainer);



// WEBPACK FOOTER //
// ./src/components/settings-container.js